// Settings page
const settings = {
  'Back to Dashboard': 'العودة إلى لوحة التحكم',
  'Manage your account and subscription': 'إدارة حسابك واشتراكك',
  'Profile': 'الملف الشخصي',
  'Your personal information': 'معلوماتك الشخصية',
  'Enter your first name': 'أدخل اسمك',
  'Enter your last name': 'أدخل اسم العائلة',
  'Connected via Google. Email cannot be changed.': 'متصل عبر Google. لا يمكن تغيير البريد الإلكتروني.',
  'Saved!': 'تم الحفظ!',
  'Save Changes': 'حفظ التغييرات',
  'Failed to load profile': 'تعذّر تحميل الملف الشخصي',
  'Failed to save profile. Please try again.': 'تعذّر حفظ الملف الشخصي. حاول مرة أخرى.',

  'Subscription': 'الاشتراك',
  'Manage your plan and billing': 'إدارة باقتك والفوترة',
  'Subscription activated successfully!': 'تم تفعيل الاشتراك بنجاح!',
  'Active': 'نشط',
  '{remaining} of {total} videos remaining (lifetime)': 'متبقٍ {remaining} من {total} فيديو (مدى الحياة)',
  '+ {count} bonus videos available': {
    zero: '+ {count} فيديو إضافي متاح',
    one: '+ فيديو إضافي واحد متاح',
    two: '+ فيديوهان إضافيان متاحان',
    few: '+ {count} فيديوهات إضافية متاحة',
    many: '+ {count} فيديو إضافي متاح',
    other: '+ {count} فيديو إضافي متاح',
  },
  '{count} videos per month • 2 min max per video': '{count} فيديو شهريًا • دقيقتان كحد أقصى لكل فيديو',
  'Renews on {date}': 'يتجدد في {date}',
  'Opening Portal...': 'جارٍ فتح البوابة...',
  'Manage Subscription': 'إدارة الاشتراك',
  'Upgrade to unlock more': 'قم بالترقية للحصول على المزيد',
  'All export formats': 'جميع صيغ التصدير',
  'Priority processing': 'معالجة ذات أولوية',
  'Dedicated account manager': 'مدير حساب مخصص',
  'Subscribe to Starter': 'اشترك في Starter',
  'Subscribe to Pro': 'اشترك في Pro',
  'Subscribe to Max': 'اشترك في Max',
  'Failed to load subscription': 'تعذّر تحميل الاشتراك',
  'Failed to create subscription': 'تعذّر إنشاء الاشتراك',
  'Failed to start upgrade process. Please try again.': 'تعذّر بدء عملية الترقية. حاول مرة أخرى.',

  'Payment Methods': 'طرق الدفع',
  'Manage your saved cards': 'إدارة بطاقاتك المحفوظة',
  'Payment method added successfully!': 'تمت إضافة طريقة الدفع بنجاح!',
  '{brand} ending in {last4}': '{brand} تنتهي بـ {last4}',
  'Card': 'بطاقة',
  'Default': 'افتراضي',
  'Expires {date}': 'تنتهي في {date}',
  'Setting...': 'جارٍ التعيين...',
  'Set as default': 'تعيين كافتراضية',
  'Your subscription will fail to renew without a card': 'لن يتجدد اشتراكك بدون بطاقة',
  'Removing...': 'جارٍ الحذف...',
  'Remove anyway': 'احذف على أي حال',
  'Remove card': 'حذف البطاقة',
  'No payment methods saved': 'لا توجد طرق دفع محفوظة',
  'Add a card to manage your subscription': 'أضف بطاقة لإدارة اشتراكك',
  'Redirecting to Stripe...': 'جارٍ التحويل إلى Stripe...',
  'Add Payment Method': 'إضافة طريقة دفع',
  'Failed to load payment methods': 'تعذّر تحميل طرق الدفع',
  'Failed to start payment method setup': 'تعذّر بدء إضافة طريقة الدفع',
  'Failed to add payment method. Please try again.': 'تعذّرت إضافة طريقة الدفع. حاول مرة أخرى.',
  'Failed to remove payment method. Please try again.': 'تعذّر حذف طريقة الدفع. حاول مرة أخرى.',
  'Failed to set default payment method. Please try again.': 'تعذّر تعيين طريقة الدفع الافتراضية. حاول مرة أخرى.',

  'Choose the language of the interface': 'اختر لغة الواجهة',
  'Sign Out': 'تسجيل الخروج',
  'Sign out of your account': 'تسجيل الخروج من حسابك',

  'Confirm Subscription': 'تأكيد الاشتراك',
  'Review your subscription details': 'راجع تفاصيل اشتراكك',
  'Plan': 'الباقة',
  '/first month': '/الشهر الأول',
  "You'll be redirected to Stripe to add a payment method.": 'سيتم تحويلك إلى Stripe لإضافة طريقة دفع.',
  'By confirming, you agree to be charged <b>{price}</b> for your first month, then <b>{renewal}</b> monthly.':
    'بالتأكيد، فإنك توافق على دفع <b>{price}</b> للشهر الأول، ثم <b>{renewal}</b> شهريًا.',
  'By confirming, you agree to be charged <b>{price}</b> monthly.': 'بالتأكيد، فإنك توافق على دفع <b>{price}</b> شهريًا.',
  'Your subscription will auto-renew each month. You can cancel anytime from Settings.':
    'يتجدد اشتراكك تلقائيًا كل شهر، ويمكنك الإلغاء في أي وقت من الإعدادات.',
  'Confirm & Subscribe': 'تأكيد والاشتراك',
};

export default settings;
